// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2x1yS","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3weND","gfeWrapper":"CalendarEvent_gfeWrapper__HmfTB"};